import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface CurrentMenuState {
  search: string;
  menu: string;
}

@Injectable({
  providedIn: 'root'
})
export class CurrentMenuStateService {
  private initialState: CurrentMenuState = { search: '', menu: '' };
  private currentStateSubject = new BehaviorSubject<CurrentMenuState>(this.initialState);

  // Observable for components to subscribe to
  currentState$ = this.currentStateSubject.asObservable();

  // Get current value
  getCurrentState() {
    return this.currentStateSubject.value;
  }

  // Update the data
  updateCurrentState(newState: Partial<CurrentMenuState>) {
    const currentState = this.currentStateSubject.value;
    const updatedState = { ...currentState, ...newState };
    this.currentStateSubject.next(updatedState);
  }

  // Reset the data to initial state
  resetCurrentState() {
    this.currentStateSubject.next(this.initialState);
  }
}
